import React from 'react';
import { useObserver, useLocalStore } from 'mobx-react-lite';
import styled from 'styled-components/macro';
import { useMst } from '../models/WithWineState';
import CartBadge from './CartBadge';
import { dispatchCartData } from '../utils/dispatchHelper';
import { MenuCartLinkProps } from '../types/MenuCartLinkProps';

const UnstyledMenuCartLink: React.FC<MenuCartLinkProps> = ({ className }) => {
  const l = '#';
  const stateTree = useMst();
  const state = useLocalStore(() => ({
    onClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
      event.preventDefault();
      event.stopPropagation();
      stateTree.widgets.cart.show();
      dispatchCartData(stateTree.session?.getCartItemsDispatchData() ?? []);
    },
  }));

  const cartMenuLinkClass = `ww-widget ww-menu-cart-link${
    className ? ` ${className}` : ``
  }`;

  return useObserver(() => (
    <a href={l} className={cartMenuLinkClass} onClick={state.onClick}>
      Cart
      <CartBadge />
    </a>
  ));
};

const MenuCartLink = styled(UnstyledMenuCartLink)`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;

  .ww-cart-badge {
    margin-left: 0.5em;
  }
`;

export default MenuCartLink;
